import { defineMessages } from 'react-intl';

const messages = defineMessages({
  notificationHubTitle: {
    id: '8nT4ws',
    defaultMessage: 'Notifications',
    description: 'Title for the notification hub content header',
  },
  noNotifications: {
    id: 'XqkUDS',
    defaultMessage: 'No notifications at this time',
    description: 'Message when there are no notifications matching the current filter',
  },
  markAllAsRead: {
    id: 'k5CjBi',
    defaultMessage: 'Mark all as read',
    description: 'Tooltip for the mark all notifications as read button',
  },
  settings: {
    id: 'rKeFqg',
    defaultMessage: 'Settings',
    description: 'Tooltip for the notification settings button',
  },
  close: {
    id: 'XoYTFd',
    defaultMessage: 'Close',
    description: 'Tooltip for the close notification hub button',
  },
});

export { messages };
